export enum GlobalJSBridgeType {
    INVALID = "INVALID",
    IPL_SWIGGY_SIX_OFFER_EXPIRY_TIMER_UPDATE = "IPL_SWIGGY_SIX_OFFER_EXPIRY_TIMER_UPDATE",
}

export interface IPLSwiggySixesDataPayload {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    expiry_time_in_sec?: number;
}

export type GlobalJSBridgePayload = {
    type: GlobalJSBridgeType;
    data?: IPLSwiggySixesDataPayload;
};
